import { render, staticRenderFns } from "./QuestionItem.vue?vue&type=template&id=14eb3f28&scoped=true"
import script from "./QuestionItem.vue?vue&type=script&lang=js"
export * from "./QuestionItem.vue?vue&type=script&lang=js"
import style0 from "./QuestionItem.vue?vue&type=style&index=0&id=14eb3f28&prod&lang=less&scoped=true"
import style1 from "./QuestionItem.vue?vue&type=style&index=1&id=14eb3f28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14eb3f28",
  null
  
)

export default component.exports